import { createApi } from '@reduxjs/toolkit/query/react';

import { ISavedLesson } from '@/interfaces/lesson';
import { IPaginationParams, IPaginationResponse } from '@/interfaces/pagination';

import { axiosBaseQuery } from './query';

export const savedLessonApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'savedLessonApi',
  tagTypes: ['List', 'saved'],
  endpoints(build) {
    return {
      saveLesson: build.mutation<void, number>({
        invalidatesTags: ['saved'],
        query: lessonId => ({
          method: 'put',
          formatResponse: response => response.data.data,
          url: `/learner/lessons/${lessonId}/save`
        })
      }),
      getLessonSaved: build.query<boolean, number>({
        providesTags: ['saved'],
        query: lessonId => ({
          formatResponse: response => response.data.data,
          url: `/learner/lessons/${lessonId}/save`
        })
      }),
      getAllSavedLessons: build.query<IPaginationResponse<ISavedLesson[]>, Partial<IPaginationParams>>({
        providesTags: ['List'],
        forceRefetch({ currentArg, previousArg }) {
          return currentArg !== previousArg;
        },
        serializeQueryArgs: ({ endpointName }) => {
          return endpointName;
        },
        merge: (currCache, newCache) => {
          currCache.total_pages = newCache.total_pages;
          currCache.page = newCache.page;
          currCache.links = newCache.links;

          if (newCache.page.page === 1) {
            currCache.data = newCache.data;
          } else {
            currCache.data.push(...newCache.data);
          }
        },
        query: params => ({
          url: '/learner/savedlessons',
          params
        })
      })
    };
  }
});

export const { useGetAllSavedLessonsQuery, useSaveLessonMutation, useGetLessonSavedQuery } = savedLessonApi;
